module.exports = __webpack_public_path__ + "media/charPick.27cd0fe1.ogg";